import React, { useEffect, useState } from 'react';
import './FileUploadFieldWarranty.scss';
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import HintWarranty from "../HintWarranty/HintWarranty";
import { useFormContext } from "react-hook-form";

const FileUploadFieldWarranty = ({ isVisible = [], changeState = null, id, hint = '', name, imageUpload} ) => {
    const [arrFiles, setArrFiles] = useState( [] );
    const [clear, setClear] = useState( true );
    const [imageUploadState] = useState(imageUpload);
    const [fullCont, setFullCont] = useState( false );

    const handleChangeStatus = ( { meta, file }, status, files ) => {
        if ( status === 'done' ) {
            handleFileRead( files ).then( result => {
                setArrFiles(result);
            })
        } else if ( status === 'removed' ) {
            let arrFiles = [];
            for ( let f of files ) {
                if ( f.file.name !== file.name ) {
                    arrFiles.push( f )
                }
            }
            handleFileRead( arrFiles ).then( result => {
                setArrFiles(result);
            })
        }
        setTimeout(function() {
            files.length === 4 ? setFullCont( true ) : setFullCont( false );
        },0)
    }

    const showPopup = () => {
        const newArr = [...isVisible];
        newArr[id] = true;
        changeState( newArr )
        setClear( true );
    }
    const convertBase64 = ( files ) => {
        let arrBase64Arr = [];

         files.map( ( f ) => {
            const promise = new Promise( ( resolve, reject ) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL( f.file )
                fileReader.onload = () => {
                     resolve( fileReader.result );
                }
                fileReader.onerror = ( error ) => {
                     reject( error );
                }
            } );

              promise.then( result => {
                  arrBase64Arr.push({
                      fileB64: result,
                      meta: f.meta
                  })
             })
        } )

        return arrBase64Arr
    }

    const handleFileRead = async ( files ) => {
        return  await convertBase64( files );
    }

    const hidePopup = () => {
        const newArr = [...isVisible];
        newArr[id] = false;
        changeState( newArr );
    }

    const clearField = () => {
        setClear( false );
        setArrFiles( [] );
    }

    const { register, setValue } = useFormContext();

    useEffect( () => {
        register( name );
        setValue( name, arrFiles );
    }, [arrFiles, register, setValue, name, fullCont] );

    return (
        <div className="file-upload-field">
            <div className="file-upload-field__title">Upload photo {hint && <HintWarranty hint={hint}/>}</div>
            <div className="file-upload-field__btn" onClick={showPopup}>Browse</div>
            {arrFiles.length ? <div className="file-upload-field__total-file">{arrFiles.length} images added</div> : ''}
            {arrFiles.length ? <div className="file-upload-field__clear-field" onClick={clearField}/> : ''}
            <div className={`file-upload-field__popup ${isVisible[id] ? 'show' : ''}`}>
                <div className="file-upload-field__card">
                    <div className={`file-upload-field__close`} onClick={hidePopup}/>
                    {imageUploadState && <img className="file-upload-field__image" src='/modules/custom/milgard_service_request/assets/images/uploadImageRecallForm.png' alt=''/>}
                    {arrFiles.length ?
                        <div className={`file-upload-field__message`}>Image uploaded! Please add more images or close
                            this window.</div> : ''}
                    {clear ? <Dropzone
                        inputContent={'Drop files here'}
                        onChangeStatus={handleChangeStatus}
                        accept="image/*,audio/*,video/*"
                        maxFiles={4}
                    /> : ''}
                    {fullCont ? <div className={`file-upload-field__quantity-limitation`}>Item limit is 4.</div> : ''}
                </div>
                <div className="file-upload-field__bg"/>
            </div>
        </div>
    )
};

FileUploadFieldWarranty.defaultProps = {
    imageUpload: false,
};

export default FileUploadFieldWarranty;
